import { createCrudSlice, createCrudSelectors } from './CrudRedux'

const categoriesSlice = createCrudSlice({
  name: 'categories',
  reducers: {
    increaseCategoryStats: (state, { payload }) => {
      const index = state.categories.findIndex((e) => e._id === payload.category)
      if (index > -1) {
        let updatedStats = { ...state.categories[index].stats }
        const stat = updatedStats[payload.reference] || 0
        updatedStats[payload.reference] = stat + 1
        const updatedCategory = { ...state.categories[index], stats: updatedStats }
        const newState = {
          categories: [
            ...state.categories.slice(0, index),
            updatedCategory,
            ...state.categories.slice(index + 1),
          ],
        }
        return { ...state, ...newState }
      }
      return state
    },
    decreaseCategoryStats: (state, { payload }) => {
      const index = state.categories.findIndex((e) => e._id === payload.category)
      if (index > -1) {
        let updatedStats = { ...state.categories[index].stats }
        const stat = updatedStats[payload.reference] || 0
        updatedStats[payload.reference] = Math.max(0, stat - 1)
        const updatedCategory = { ...state.categories[index], stats: updatedStats }
        const newState = {
          categories: [
            ...state.categories.slice(0, index),
            updatedCategory,
            ...state.categories.slice(index + 1),
          ],
        }
        return { ...state, ...newState }
      }
      return state
    },
  },
})

export const CategoriesActions = categoriesSlice.actions

export const CategoriesSelectors = {
  ...createCrudSelectors({ name: 'categories' }),
}

export default categoriesSlice.reducer
